export enum adminRecruitmentEditTypes {
    FETCH_ADMIN_RECRUITMENT_EDIT_REQUEST = "FETCH_ADMIN_RECRUITMENT_EDIT_REQUEST",
    FETCH_ADMIN_RECRUITMENT_EDIT_SUCCESS = "FETCH_ADMIN_RECRUITMENT_EDIT_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_EDIT_FAILURE = "FETCH_ADMIN_RECRUITMENT_DETAIL_FAILURE",
  }